import _ from 'lodash';
import ObservablePropertyDescriptorObject from '../../utils/ObservablePropertyDescriptorObject';
import PropertyDescriptor from '../../utils/PropertyDescriptor';
import ModelActionPropertySendMessage from "./ModelActionPropertySendMessage";
import ModelActionPropertyRunScript from "./ModelActionPropertyRunScript";
import ModelActionPropertyRefreshDataSource from "./ModelActionPropertyRefreshDataSource";
import ModelActionPropertyAssert from "./ModelActionPropertyAssert";

export default class Model extends ObservablePropertyDescriptorObject {

    type = new PropertyDescriptor('none', '动作类型', "基本", "enum", "#anticon-INGRESS-GLYPH-CREATE-", {
        values: [
            new PropertyDescriptor("none", "无", "", "string", "#anticon-no-data"),
            new PropertyDescriptor("refreshDataSource", "刷新数据源", "", "string", "#anticon-icon-test"),
            new PropertyDescriptor("runScript", "执行脚本", "", "string", "#anticon-Documentation"),
            new PropertyDescriptor("sendMessage", "发送消息", "", "string", "#anticon-noun_Soundwave_1786379"),
            new PropertyDescriptor("assert", "断言", "", "string", "#anticon-exe-public-address-primary"),
        ],
    });

    settings = new PropertyDescriptor(null, '参数', "高级", "propertygrid", "#anticon-profile-setting", {
        visible: false,
    });

    constructor(opts = {}) {
        super();

        this.defineAllProperties();

        for (var p in opts) {
            if (p !== "settings")
                this[p] = opts[p];
        }

        this.settings = this.createArgs(this.type, opts.settings);
    }

    createArgs(type, opts) {

        if (type === "sendMessage") {
            return new ModelActionPropertySendMessage(opts);
        }

        else if (type === "runScript") {
            return new ModelActionPropertyRunScript(opts);
        }

        else if (type === "refreshDataSource") {
            return new ModelActionPropertyRefreshDataSource(opts);
        }

        else if (type === "assert") {
            return new ModelActionPropertyAssert(opts);
        }

        // else if (type === "javascript") {
        //     return new ModelDataSourcePropertyJavascript(opts);
        // }

        // else if (type === "script-service") {
        //     return new ModelDataSourcePropertyScriptService(opts);
        // }

        // else if (type === "service") {
        //     return new ModelDataSourcePropertyService(opts);
        // }

        else
            return null;
    }

    onPropertyValueChanged(name, valOld, valNew, subName, args) {

        // console.log(name, valNew);

        if (name === "type") {
            this.settings = this.createArgs(valNew);
            this.setPropertyVisible("settings", valNew !== "none");
        }
    }

    run(data, opts) {
        return this.settings && this.settings.run(data, opts);
    }

    toJsonObject() {

        let o = super.toJsonObject();

        return o;
    }

    toString() {
        const txt = this.settings && this.settings.toString();

        return {
            svg: `${this._.type._sys.__mapValues[this.type].svg}`,
            text: `${this._.type._sys.__mapValues[this.type].alias}${txt ? " - " + txt : ""}`
        };
    }
}
